import React from 'react';
import ReactDOM from 'react-dom/client';

import { removeStoredSignupPassword } from '@Shared/utils/useLocalStorage';

import { App } from './app/ui';

import '@Shared/assets/styles/index.less';

removeStoredSignupPassword();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
